export enum USER_STATUS_TYPE {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum USER_ROLE_TYPE {
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  BUYER_ADMIN = 'buyer_admin',
  BUYER = 'buyer',
  SELLER = 'seller',
  CHECK_IN = 'checkin',
}

export enum OFFER_STATE_CODE {
  BUYING = 'buying',
  SHIPPED = 'shipped',
  RECEIVED = 'received',
  CHECK_IN = 'check_in',
  RECONCILED = 'reconciled',
  CLOSED = 'closed',
}

export enum CONDITION_TYPE {
  NEW = 'new',
  USED = 'used',
  REPAIR = 'repair',
}

export enum OFFER_REVISION_STATE_CODE {
  OPEN = 'open',
  SUBMITTED = 'submitted',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  VOID = 'void',
}

export enum SEARCH_TYPE {
  BOOK_SEARCH_BY_ISBN = 'bookSearchByISBN',
  SELLERS_SEARCH = 'sellersSearch',
  OFFER_ITEM = 'offerItem',
}

export interface User {
  id: string
  name: string
  email: string
  phoneNumber: string
  auth0Id: string
  roleId: string
  status: USER_STATUS_TYPE
  role?: Role
  userGroup: UserGroup
}

export interface Role {
  id: string
  name: string
  auth0Id: string
}

export interface Auth0UserProfile {
  auth0Id: string
  email: string
  email_verified: string
  iss?: string
  name: string
  nickname: string
  picture: string
  roles: [USER_ROLE_TYPE] | null
}

export interface UserGroup {
  id: string
  description: string
  priceMultiplier: number
}

export interface Seller {
  id: string
  buyerUserId: string
  name: string
  email: string
  phoneNumber?: string
  address1?: string
  address2?: string
  city?: string
  state?: string
  zip?: string
}

export interface SellerUser {
  id: string
  userId: string
  sellerUserId: string
}

export interface Offer {
  id: string
  buyerUserId: string
  sellerUserId: string
  sellerId: string
  code?: string | number
  notes?: string
  offerItems?: OfferItem[]
  offerTotal?: number
}

export interface OfferCart {
  id: string
  buyerUserId: string
  sellerUserId: string
  sellerId: string
  notes?: string
  offerItems?: OfferItem[]
}

export interface OfferItem {
  id: string
  bookId: string
  conditionId: string
  offerId: string
  offerRevisionId: string
  replacedByRevisionId: string
  offerPrice: number
  quantity: number
  notes?: string
  book?: Book
  condition?: Condition
}

export interface Condition {
  id: string
  name: string
  label: string
  ordering: number
  conditionType: string
}

export interface GuidePrice {
  id: string
  bookId: string
  price: number
  quantity: number
  conditionId?: string
  condition?: Condition
}

export interface Book {
  id: string
  isbn: string
  title: string
  guidePrices?: GuidePrice[]
}

export interface Inventory {
  id: string
  isbn: string
  code: string
  cashmonkeySkuId: string
  bookId: string
  conditionId: string
  sellerId: string
  offerId: string
  offerItemId: string
  sourceId: string
  book?: Book
  condition?: Condition
  offer?: Offer
  offerItem?: OfferItem
  seller?: Seller
}
